export default __webpack_public_path__ + "f1aa9fb15a82bb02c1521dd9dede8d9e.svg";